module.exports = __webpack_public_path__ + "static/media/admin_canvas_sleeve_icon.c786bbc9.svg";